<template>
  <v-app>
    <v-app-bar color="primary" flat app dark>
      <v-app-bar-nav-icon style="position: absolute" :to="'/'">
        <v-icon large color="white">mdi-chevron-left</v-icon>
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-app-bar-title style="min-width: fit-content;">
        <span v-if="album">{{ album.title.length > 12 ? album.title.slice(0, 12) + '…' : album.title }}</span>
      </v-app-bar-title>
      <v-spacer></v-spacer>
      <v-btn
        size="small"
        variant="text"
        color="white"
        @click="openAlbumEdit"
      >編集</v-btn>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <v-progress-linear
          indeterminate
          color="primary"
          height="3"
          v-if="isFetching || isUploading"
        ></v-progress-linear>
        <!--写真と動画の合計を表示-->
        <v-row class="pb-3 pt-3">
            <h3 class="pr-6 pl-4">全件：{{ photoTotal + movieTotal }}</h3>
            <h3 class="pr-6 ">写真：{{ photoTotal }}</h3>
            <h3 class="pr-6 ">動画：{{ movieTotal }}</h3>
          </v-row>
        <v-row dense>
          <v-col
            v-for="(c, i) in contents"
            :key="i"
            cols="6"
          >
            <v-card
              class="pa-2"
              variant="outlined"
              tile
              @click="selectMedia(c)"
              style="position: relative; color: #f0f0f0"
            >
              <v-img
                :src="c.thumbnailUrl ?? undefined"
                aspect-ratio="1"
                class="pa-0"
              />
              <span
                style="position: absolute; top: 10px; right: 10px;"
              >
                <v-chip
                  v-if="c.status === 'requested' || c.status === 'inProgress'"
                  variant="flat"
                >
                  処理中
                </v-chip>
                <v-chip
                  v-if="c.status === 'completed'"
                  color="primary"
                  variant="flat"
                >
                  完了
                </v-chip>
                <v-chip
                  v-if="c.status === 'failed'"
                  color="red"
                  variant="flat"
                >
                  失敗
                </v-chip>
              </span>
            </v-card>
          </v-col>
        </v-row>

        <v-overlay
          :model-value="selectedMedia !== null"
          class="memoru-media-overlay"
          persistent
        >
          <div v-if="selectedMedia" class="memoru-media-modal">
            <div class="memoru-media-modal__top">
              <v-btn
                color="red"
                variant="flat"
                size="small"
                @click="() => isDeleteDialogOpen = true"
              >
                削除
              </v-btn>
            </div>

            <div class="memoru-media-modal__body">
              <v-img
                v-if="selectedMedia.category === 'photo'"
                class="memoru-media"
                :src="selectedMedia.previewImageUrl ?? undefined"
                :cover="false"
              />
              <video
                v-if="selectedMedia.category === 'movie'"
                class="memoru-media"
                controls
              >
                <source :src="selectedMedia.previewImageUrl ?? undefined" />
              </video>
            </div>

            <div class="memoru-media-modal__bottom">
              <v-btn @click="selectMedia(null)" variant="flat" color="primary">
                閉じる
              </v-btn>
            </div>
          </div>
        </v-overlay>
      </v-container>
    </v-main>
    <div class="fab-wrapper">
      <!-- メニューアイテム部分 -->
      <v-slide-y-reverse-transition>
        <div v-show="isFabOpen" class="fab-items mb-4">
          <v-btn
            color="primary"
            rounded="pill"
            size="large"
            class="mb-3"
            prepend-icon="mdi-video"
            @click="videoSelectClicked"
          >
            動画をアップロード
          </v-btn>

          <v-btn
            color="primary"
            rounded="pill"
            size="large"
            class="mb-3"
            prepend-icon="mdi-camera"
            @click="imageSelectClicked"
          >
            画像をアップロード
          </v-btn>
        </div>
      </v-slide-y-reverse-transition>

      <!-- メインのFABボタン -->
      <v-btn
        color="primary"
        icon
        size="x-large"
        elevation="4"
        @click="isFabOpen = !isFabOpen"
      >
        <v-icon size="large">
          {{ isFabOpen ? 'mdi-close' : 'mdi-plus' }}
        </v-icon>
      </v-btn>

      <!-- 隠しファイル入力（変更なし） -->
      <input 
        ref="imageInput"
        type="file"
        class="hidden-input"
        accept="image/*"
        @change="imageSelected"
        multiple
      />
      <input 
        ref="videoInput"
        type="file"
        class="hidden-input"
        accept="video/*"
        @change="videoSelected"
        multiple
      />
    </div>

    <!-- 削除モーダル -->
    <v-dialog v-model="isDeleteDialogOpen" class="delete-absence-dialog">
      <v-card>
        <div class="d-flex justify-space-around pt-3 pb-3">
          <v-card-title class="headline lighten-2">削除しますか？</v-card-title>
        </div>
        <div class="d-flex justify-space-around pt-3 pb-3">
          <v-card-actions>
            <v-btn color="white" variant="flat" @click="() => (isDeleteDialogOpen = false)">
              キャンセル
            </v-btn>
            <v-btn
              color="error"
              class="ml-5"
              variant="flat"
              @click="deleteMedia"
              :loading="isDeleting"
            >
              削除
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      :model-value="editingAlbum !== null"
      @update:model-value="val => { if (!val) closeAlbumEdit() }"
      class="delete-absence-dialog"
    >
      <v-card v-if="editingAlbum">
        <div class="d-flex justify-space-around pt-3 pb-3">
          <v-card-title class="headline lighten-2">アルバムを編集</v-card-title>
        </div>
        <v-card-text>
          <div class="my-3">
            <span class="mb-2">年度</span>
            <v-text-field 
              type="number"
              density="compact"
              hide-details
              variant="outlined"
              v-model="editingAlbum.year"
              color="primary"
              :disabled = true
            />
          </div>
          <div class="my-3">
            <span class="mb-2">クラス</span>
            <v-select
              variant="outlined"
              multiple
              density="compact"
              hide-details
              v-model="editingAlbum.nurseryClasses"
              :items="classes"
              item-value="classId"
              item-title="className"
              return-object
              color="primary"
            ></v-select>
          </div>
          <div class="my-3">
            <span class="mb-2">アルバムのタイトル</span>
            <v-text-field 
              density="compact"
              hide-details
              variant="outlined"
              v-model="editingAlbum.title"
              color="primary"
            />
          </div>
          <div class="my-3">
            <span class="mb-2">コメント</span>
            <v-text-field 
              density="compact"
              hide-details
              variant="outlined"
              v-model="editingAlbum.comment"
              color="primary"
            />
          </div>
          <div class="my-3">
            <div class="d-flex align-center">
              <span class="mb-2">公開開始日 *</span>
              <v-spacer />
            </div>
            <v-text-field
              type="datetime-local"
              density="compact"
              hide-details
              variant="outlined"
              v-model="editingAlbum.availableAfter"
              color="primary"
            />
          </div>
          <div class="my-3">
            <div class="d-flex align-center">
              <span class="mb-2">公開終了日</span>
              <v-spacer />
            </div>
            <v-text-field 
              type="datetime-local"
              density="compact"
              hide-details
              variant="outlined"
              v-model="editingAlbum.availableBefore"
              color="primary"
            />
          </div>

        </v-card-text>
        <div class="d-flex justify-space-around pt-3 pb-3">
          <v-card-actions>
            <v-btn color="white" variant="flat" @click="closeAlbumEdit">
              キャンセル
            </v-btn>
            <v-btn
              color="primary"
              class="ml-5"
              variant="flat"
              :loading="isUpdating"
              @click="updateAlbum"
            >
              保存
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script lang="ts">
//import Vue from 'vue';
import { defineComponent } from "vue";

import { PostMeRequest } from '@/model/Request';
import { memoruAlbumModule } from '@/store/dataModules/memoruAlbumModule';
import { auth0Module } from '@/store/dataModules/auth0Module';
import LocalDataService from '@/service/LocalDataService';
import { MeNurserySchoolResponse, MultimediaAlbumResponse, MultimediaResponse } from 'chaild-api/lib';
import { meModule } from '@/store/dataModules/meModule';
import ApiMemoru from '@/api/ApiMemoru';
import dayjs from 'dayjs';
import { nurseryModule } from '@/store/dataModules/nurseryModule';

interface DataType {
  selectedMedia: MultimediaResponse | null;
  isFabOpen: boolean;
  alubmId: string | number | null;
  isFetching: boolean;
  isDeleting: boolean;
  isUpdating: boolean;
  isUploading: boolean;
  isDeleteDialogOpen: boolean;
  editingAlbum: MultimediaAlbumResponse | null;
  photoTotal: number; //写真の合計
  movieTotal: number; //動画の合計
}

const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));

export default defineComponent({
  data(): DataType {
    return {
      selectedMedia: null,
      isFabOpen: false,
      alubmId: null,
      isFetching: false,
      isDeleting: false,
      isUpdating: false,
      isUploading: false,
      isDeleteDialogOpen: false,
      editingAlbum: null,
      photoTotal: 0,
      movieTotal: 0,
    }
  },
  computed: {
    album() {
      return memoruAlbumModule.album
    },
    contents() {
      return memoruAlbumModule.contents;
    },
    classes() {
      return nurseryModule.allClasses as readonly any[] | undefined;
    },
  },
  methods: {
    selectMedia(media: MultimediaResponse | null) {
      this.selectedMedia = media;
    },
    imageSelectClicked() {
      const imageInput = this.$refs.imageInput as HTMLInputElement;
      if (imageInput) {
        imageInput.click();
      }
    },
    videoSelectClicked() {
      const videoInput = this.$refs.videoInput as HTMLInputElement;
      if (videoInput) {
        videoInput.click();
      }
    },
    async imageSelected() {
      const imageInput = this.$refs.imageInput as HTMLInputElement;
      if (this.alubmId && imageInput && imageInput.files) {
        const files = Array.from(imageInput.files);
        const albumId = String(this.alubmId);

        this.isUploading = true;

        await Promise.all(files.map((file) => {
          const date = dayjs(file.lastModified).toISOString();
          return ApiMemoru.getUploadEndpoint({
            albumId,
            filename: file.name,
            date,
            category: 'photo'
          }).then((response) => {
            return ApiMemoru.uploadFile({
              url: response.preSignedUploadUrl,
              file: file
            })
          })
        }));

        await sleep(10000)

        this.isUploading = false;

        memoruAlbumModule.listAlbumContents({ albumId })
        this.getAlbumAndContents();
      }
    },
    async videoSelected() {
      const imageInput = this.$refs.videoInput as HTMLInputElement;
      if (this.alubmId && imageInput && imageInput.files) {
        const files = Array.from(imageInput.files);
        const albumId = String(this.alubmId);

        this.isUploading = true;

        await Promise.all(files.map((file) => {
          const date = dayjs(file.lastModified).toISOString();
          return ApiMemoru.getUploadEndpoint({
            albumId,
            filename: file.name,
            date,
            category: 'movie'
          }).then((response) => {
            return ApiMemoru.uploadFile({
              url: response.preSignedUploadUrl,
              file: file
            })
          })
        }));

        await sleep(10000)

        this.isUploading = false;

        memoruAlbumModule.listAlbumContents({ albumId })
        this.getAlbumAndContents();
      }
    },
    async deleteMedia() {
      if (this.selectedMedia) {
        this.isDeleting = true;
        await ApiMemoru.deleteAlbumContents({
          multimediaId: this.selectedMedia.multimediaId
        });
        this.isDeleting = false;
        this.isDeleteDialogOpen = false;
        this.selectedMedia = null;
        this.getAlbumAndContents();
      }
    },
    async getAlbumAndContents() {
      if (this.alubmId) {
        this.isFetching = true;
        await Promise.all([
          memoruAlbumModule.getAlbum({albumId: this.alubmId}), 
          memoruAlbumModule.listAlbumContents({ albumId: this.alubmId })
        ])
        this.photoTotal = 0; //写真の合計リセット
        this.movieTotal = 0; //動画の合計リセット
        this.Total();
        this.isFetching = false;
      }
    },
    openAlbumEdit() {
      if (this.album) {
        let album = {...this.album};
        album.availableAfter = dayjs(this.album.availableAfter).format('YYYY-MM-DDTHH:mm:ss');
        if (this.album.availableBefore) {
          album.availableBefore = dayjs(this.album.availableBefore).format('YYYY-MM-DDTHH:mm:ss');
        }
        this.editingAlbum = album;
      }
    },
    closeAlbumEdit() {
      this.editingAlbum = null;
    },
    async updateAlbum() {
      if (this.editingAlbum) {
        this.isUpdating = true;
        await ApiMemoru.updateAlbum({
          albumId: this.editingAlbum.albumId,
          year: this.editingAlbum.year,
          title: this.editingAlbum.title,
          comment: this.editingAlbum.comment,
          nurseryClassIds: this.editingAlbum.nurseryClasses.map((nc) => nc.classId),
          availableAfter: dayjs(this.editingAlbum.availableAfter).toISOString(),
          availableBefore: this.editingAlbum.availableBefore ? dayjs(this.editingAlbum.availableBefore).toISOString() : null
        })
        this.isUpdating = false;

        this.editingAlbum = null;
        this.getAlbumAndContents();
      }
    },
    //写真と動画の合計
    Total() {
      memoruAlbumModule.contents.forEach(items => {
        if (items.deletedAt === null && items.status === 'completed') {
          if (items.category === 'photo') {
            this.photoTotal += 1;
          }
          if (items.category === 'movie') {
            this.movieTotal += 1;
          }
        }
      })
    },
  }, 
  async mounted() {
    const albumId = this.$route.params.albumId as string;
    if (albumId) {
      this.alubmId = albumId;
      this.getAlbumAndContents();
    }

    meModule.setTabIndex('memoru');

    const user = LocalDataService.getUser();
    if (user) {
      let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
      if (!nurserySchool) {
        nurserySchool = user.nurserySchools[0];
      }
      const nurseryId = nurserySchool.nurseryId;
      nurseryModule.getNurseryClass(nurseryId)
    }
  }
});
</script>
<style lang="scss" scoped>
.hidden-input {
  display: none;
}
/* 画面右下に固定するためのスタイル [2] */
.fab-wrapper {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: flex-end; /* 右寄せ */
}
/* 展開アイテムのスタイル [3] */
.fab-items {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.memoru-media-overlay {
  padding: 16px;
}

.memoru-media-modal {
  /* 画面内に収める */
  width: min(92vw, 720px);
  max-height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
}

.memoru-media-modal__top {
  display: flex;
  justify-content: flex-end;
  padding: 12px 12px 0 12px;
}

.memoru-media-modal__body {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  overflow: auto;
}

.memoru-media-modal__bottom {
  padding: 0 12px 12px 12px;
  display: flex;
  justify-content: center;
}

/* img/video の縦幅を画面内に収める */
.memoru-media {
  max-width: 100%;
  max-height: calc(100vh - 200px);
}

video.memoru-media {
  width: 100%;
  height: auto;
  object-fit: contain;
}
</style>
